var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 8.62499V1.91666L10.416 3.83332",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 1.91666L14.2487 3.83332",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73047 12.4583H6.95672C7.32089 12.4583 7.64672 12.6596 7.80964 12.9854L8.93089 15.2279C9.25672 15.8796 9.91797 16.2917 10.6463 16.2917H14.0292C14.7576 16.2917 15.4188 15.8796 15.7446 15.2279L16.8659 12.9854C17.0288 12.6596 17.3642 12.4583 17.7188 12.4583H21.8971",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53971 4.91626C4.14721 5.41459 2.74805 7.40793 2.74805 11.5V14.375C2.74805 19.1667 4.66471 21.0833 9.45638 21.0833H15.2064C19.998 21.0833 21.9147 19.1667 21.9147 14.375V11.5C21.9147 7.40793 20.5155 5.41459 17.123 4.91626",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.a382004dea7a33e37602919aa2721a90.svg";
export { ForwardRef as ReactComponent };